{
  "settings_password_form": {
    "title": "Password",
    "description": "When updating your password, please ensure it is at least 12 characters long.",
    "action": "Update Password",
    "details": {
      "current_password": {
        "label": "Current Password"
      },
      "new_password": {
        "label": "New Password"
      },
      "confirm_new_password": {
        "label": "Confirm New Password"
      }
    },
    "notifications": {
      "success": "Your password has been updated",
      "no_match": "The provided password does not match your current password",
      "update_failed": "Failed to update password. Please try again later",
      "update_invalid": "Failed to update password. Please fix the errors and try again"
    },
    "errors": {
      "current_password_required": "Please enter your current password.",
      "new_password_min_length": "Password must be at least 12 characters long.",
      "confirm_new_password_required": "Please confirm your new password.",
      "confirm_new_password_mismatch": "Passwords do not match.",
      "no_match": "The provided password does not match your current password."
    }
  },
  "two_factor_status_card": {
    "title": "Two-factor authentication",
    "description": "Add an extra layer of security to your account by requiring a code from your authenticator app in addition to your password.",
    "required_notice": "Two-factor authentication is required for your account.",
    "reset_in_progress_notice": "Your previous authenticator app and recovery codes no longer work. Finish the steps below to secure your account again — if you stop now, you'll sign in with just your password until you set up an authenticator app.",
    "not_enrolled": {
      "status": "Not enabled",
      "action": "Enable two-factor authentication"
    },
    "enrolled": {
      "status": "Enabled",
      "action": "Reset authenticator app",
      "view_recovery_codes": "View recovery codes",
      "regenerate_recovery_codes": "Regenerate recovery codes",
      "recovery_codes_failed": "We couldn't load your recovery codes.",
      "retry": "Try again"
    },
    "notifications": {
      "enabled": "Two-factor authentication has been enabled",
      "reset": "Your authenticator app has been reset",
      "enable_failed": "Failed to start two-factor authentication setup. Please try again later",
      "reset_failed": "Failed to reset your authenticator app. Please try again later",
      "regenerate_failed": "Failed to regenerate recovery codes. Please try again later"
    }
  },
  "enable_two_factor_flow": {
    "description": "Scan this QR code with your authenticator app, then enter the 6-digit code it generates below.",
    "qr_code_failed": "We couldn't load the QR code.",
    "qr_code_retry": "Try again",
    "url_fallback": "Can't scan the code? Enter this setup key into your app instead: {url}",
    "code_label": "Authentication code",
    "action": "Confirm and enable",
    "cancel": "Cancel",
    "errors": {
      "code_required": "Please enter the 6-digit code from your authenticator app.",
      "code_invalid": "Please enter a valid 6-digit code.",
      "code_incorrect": "That code was incorrect. Please try again.",
      "confirm_failed": "Failed to enable two-factor authentication. Please try again later"
    }
  },
  "recovery_codes_card": {
    "title": "Recovery codes",
    "description": "Store these recovery codes somewhere safe. Each one can only be used once to sign in if you lose access to your authenticator device.",
    "copy_all": "Copy all"
  },
  "confirm_password_modal": {
    "title": "Confirm your password",
    "description": "For your security, please confirm your password to continue.",
    "password_label": "Password",
    "action": "Confirm",
    "errors": {
      "password_required": "Please enter your password.",
      "password_incorrect": "The password you entered is incorrect."
    }
  },
  "modals": {
    "delete_invite_modal": {
      "header": "Delete invite?",
      "body": "Are you sure you want to delete the invite to {email}?"
    },
    "remove_member_modal": {
      "header": "Remove {name}?",
      "body": "Are you sure you want remove {name} from the team?"
    },
    "swap_owner_modal": {
      "header": "Make {name} the owner?",
      "body": "Are you sure you want make {name} the owner of this team? Only they can revert this in the future."
    }
  },
  "members_table": {
    "caption": "Team Members",
    "headings": {
      "name": "Name",
      "email": "Email",
      "role": "Role"
    },
    "buttons": {
      "make_owner": "Make Owner"
    },
    "pending_invite_badge": "Pending Invite"
  },
  "member_details": {
    "header_owner": "Owner Details",
    "header_default": "Member Details",
    "section_titles": {
      "name": "Name",
      "email": "Email",
      "company_name": "Company Name",
      "role": "Role"
    }
  },
  "member_role_badge": {
    "full_access": "Full Access",
    "restricted_access": "Restricted Access"
  },
  "plan_card": {
    "logo_alt": "SparkLayer logo",
    "default_billing_duration": "/month",
    "custom_price": "Custom"
  },
  "plan_display": {
    "title": "Current Plan",
    "title_pending": "Pending Plan",
    "cards": {
      "plan": {
        "title": "Plan",
        "confirm_plan": "Confirm Plan"
      },
      "orders": {
        "title": "Monthly orders",
        "body": "out of {val}"
      },
      "sales_agents": {
        "title": "Sales agents",
        "body": "available.",
        "link": "Add more",
        "tooltip": "Speak with our team if you'd like to add more sales agents to your account."
      }
    },
    "notes": {
      "order_count": "*Your current plan allows {val} orders per month. The usage above shows how many orders have been placed in the last 30 days.",
      "tax": "*Depending on your billing address there may be added tax to the price of your subscription."
    },
    "enterprise_footer": {
      "body": "If you have any questions about your Enterprise charges, please contact us. Visit our billing guide to learn more about how billing works.",
      "link": "Billing guide"
    }
  }
}
